module.exports = __webpack_public_path__ + "static/media/SortVisualiser.86a3b7b7.jpg";